import React from 'react';
import Layout from '@components/layout';
import { getTranslationCache } from '@repo/sanity-static-localization-provider-library';
import {
  InternationalContext,
  useInternationalHelper,
} from '@repo/gatsby-localization-helpers';
import { uiComponentsLocalizationData } from '@repo/static-translations';

const InternationalContextWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const mockTranslationCache = getTranslationCache(
    null,
    uiComponentsLocalizationData
  );

  const staticContentLocalizer = useInternationalHelper(
    'en-us',
    mockTranslationCache,
    uiComponentsLocalizationData
  );

  return (
    <InternationalContext.Provider value={staticContentLocalizer}>
      {children}
    </InternationalContext.Provider>
  );
};

function PageWrapper({ element }: { element: React.ReactElement }) {
  return (
    <InternationalContextWrapper>
      <Layout>{element}</Layout>
    </InternationalContextWrapper>
  );
}

export default PageWrapper;
